import {
    Box,
    Button,
    Grid,
    IconButton,
    InputAdornment,
    Typography,
} from "@mui/material";
import {
    VisibilityOutlined,
    VisibilityOffOutlined
} from '@mui/icons-material';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from 'yup';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { toast } from 'react-toastify';

import LinkRouter from "../../components/LinkRouter";

import { useActions } from "../../hooks/useActions";
import { ILoginModel } from "./types";
import { ServerError } from "../../store/types";
import { toLowerFirstLetter } from "../../http_comon";

import { AuthHeaderTypography } from "./styled";
import { TextFieldStyle } from "../../components/TextField/styled";
import { contacts } from "../../assets/backgrounds";

const recaptchaEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED !== 'false';

const SignIn = () => {
    const { LoginUser } = useActions();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const loginModel: ILoginModel = { email: '', password: '' };


    const LogInSchema = Yup.object().shape({
        email: Yup.string().required("Логін є обов'язковий").label('Логін'),
        password: Yup.string().required().label('Пароль')
    });

    const formik = useFormik({
        initialValues: loginModel,
        validationSchema: LogInSchema,
        onSubmit: async (values, { setFieldError }) => {
            let reCaptchaToken = '';
            if (recaptchaEnabled) {
                if (!executeRecaptcha) {
                    toast.error("Помилка перевірки Captcha");
                    return;
                }
                reCaptchaToken = await executeRecaptcha();
            }
            try {
                await LoginUser(values, reCaptchaToken);
                navigate("/admin");
                toast.success('Вхід успішний!');
            }
            catch (exeption) {
                const serverErrors = exeption as ServerError;
                if (serverErrors.errors)
                    Object.entries(serverErrors.errors).forEach(([key, value]) => {
                        if (Array.isArray(value)) {
                            let message = "";
                            value.forEach((item) => {
                                message += `${item} `;
                            });
                            setFieldError(toLowerFirstLetter(key), message);
                        }
                    });
                let message = "Помилка входу! \n";
                if (serverErrors.status === 400)
                    message += "Помилка перевірки.";
                if (serverErrors.status === 401)
                    message += "Користувача з введеними даними не існує.";
                toast.error(message, { position: "top-right" });
            }

        }
    });

    const { errors, touched, handleSubmit, getFieldProps } = formik;

    const handleShowPassword = () => {
        setShowPassword((show) => !show);
    };

    return (
        <Grid container sx={{ height: "100vh" }}>
            <Grid
                item
                xs={false}
                sm={4}
                md={6}
                sx={{
                    backgroundImage: `url(${contacts})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Grid item xs={12} sm={8} md={6}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: "100%"
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: "10px"
                    }}>

                    <AuthHeaderTypography sx={{ marginTop: "98px" }}>
                        Вхід
                    </AuthHeaderTypography>
                    <FormikProvider value={formik} >
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit} >

                            <Grid container>
                                <Grid item xs={12} sx={{ height: "40px", marginTop: "92px" }}>
                                    <TextFieldStyle
                                        fullWidth
                                        variant="standard"
                                        type="text"
                                        label="Логін"
                                        {...getFieldProps('email')}
                                        error={Boolean(touched.email && errors.email)}
                                        helperText={touched.email && errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ height: "40px", marginTop: "110px" }}>
                                    <TextFieldStyle
                                        fullWidth
                                        variant="standard"
                                        type={showPassword ? 'text' : 'password'}
                                        label="Пароль"
                                        {...getFieldProps('password')}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton sx={{ padding: "3px" }} onClick={handleShowPassword} edge="start">
                                                        {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={Boolean(touched.password && errors.password)}
                                        helperText={touched.password && errors.password}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ marginTop: "85px" }}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        type="submit"
                                    >
                                        Увійти
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    </FormikProvider>
                </Box>
            </Grid>
        </Grid>
    );
}

export default SignIn;